export enum Features {
  ADVANCED_DASHBOARDS = 'advancedDashboards',
  PREMIUM_DASHBOARDS = 'premiumDashboards',
  ADVANCED_REPORTING = 'advancedReporting',
  AUTO_SOURCE_DEEDS = 'autoSourceDeeds',
  BASIC_DASHBOARDS = 'basicDashboards',
  BROWSING_EXTERNAL_OPPORTUNITIES = 'browsingExternalOpportunities',
  COMMUNITIES = 'communities',
  CORPORATE_DONATIONS = 'corporateDonations',
  DONATION_CREDIT = 'donationCredit',
  DONATION_MATCHING = 'donationMatching',
  DONATIONS = 'donations',
  EMPLOYEE_AFFILIATIONS = 'employeeAffiliations',
  EVENTS = 'events',
  FUNDRAISERS = 'fundraisers',
  EXTERNAL_CORPORATE_DONATIONS = 'externalCorporateDonations',
  EXTERNAL_DONATIONS = 'externalDonations',
  EXTERNAL_MATCHING = 'externalMatching',
  AI_RECEIPT_READER = 'receiptReader',
  EXTERNAL_MATCHING_RULES = 'externalMatchingRules',
  PAYPAL_COMMERCE_LINK = 'payPalCommerceLink',
  PAYROLL_API = 'payrollApi',
  PAYROLL_FLAT_FILE = 'payrollFlatFile',
  RECURRING_DONATIONS = 'recurringDonations',
  REPORTS = 'reports',
  SLACK = 'slack',
  SURVEYS = 'surveys',
  USER_CREATE_DEED = 'userCreateDeed',
  USER_DRAFT_DEED = 'userDraftDeed',
  USER_LOG_OFFLINE_HOURS = 'userLogOfflineHours',
  USER_NOMINATE_NONPROFIT = 'userNominateNonprofit',
  USER_NOMINATE_NONPROFIT_FOR_MATCHING = 'userNominateNonprofitForMatching',
  USER_PUBLISH_DEED = 'userPublishDeed',
  USER_CREATE_EVENT = 'userCreateEvent',
  USER_CREATE_FUNDRAISER = 'userCreateFundraiser',
  VOLUNTEER_TIME_OFF = 'volunteerTimeOff',
  VOLUNTEERING = 'volunteering',
  VOLUNTEER_REWARD = 'volunteerReward',
  PLEDGE = 'pledge',
  COMMUNITIES_SUPER_LEADS = 'communitiesSuperLeads',
  ACTIONS = 'actions',
  PRODUCTBOARD = 'productboard',
  GIVING_PLEDGE_CAMPAIGNS = 'givingPledgeCampaigns',
  PARTIAL_MATCHING = 'partialMatching',
  BADGES = 'badges',
  PAGINATED_DEEDS_SEARCH = 'usePaginatedDeedSearch',
  BUDGET_LIMIT_ASSERTION_TYPE = 'budgetLimitAssertionType',
  EDIT_DONATION_AMOUNT = 'editDonationAmount',
  GRANTS = 'grants',
  PAC_UPLOAD = 'pacUpload',
  MULTIPLE_SHIFTS = 'multipleShifts',
  UNWRAPPED = 'unwrapped',
  IMPACT_AI = 'impactAi',
  TEAMS = 'teams',
  IMPERSONATION = 'impersonation',
  CHALLENGES = 'challenges',
}
